"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _material = require("@mui/material");

var _Icon = require("../Icon");

var _Typography = require("../Typography");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["className"],
    _excluded2 = ["children", "title", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledTooltip = (0, _material.styled)(function (_ref) {
  var className = _ref.className,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Tooltip, _objectSpread(_objectSpread({}, props), {}, {
    classes: {
      popper: className
    }
  }));
}, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "isError";
  }
})(function (_ref2) {
  var _$concat, _ref3;

  var theme = _ref2.theme,
      isError = _ref2.isError;
  return _ref3 = {}, (0, _defineProperty2.default)(_ref3, "& .".concat(_utilities.classes.components.MuiTooltip.arrow), {
    "&::before": {
      backgroundColor: "#fff",
      border: "1px solid ".concat(theme.palette.brand.grey.lightGrey)
    },
    color: theme.palette.brand.grey.lightGrey,
    fontSize: "1.25rem",
    width: 21
  }), (0, _defineProperty2.default)(_ref3, "& .".concat(_utilities.classes.components.MuiTooltip.tooltip), (_$concat = {}, (0, _defineProperty2.default)(_$concat, "& .".concat(_utilities.classes.components.MuiIcon.root), {
    lineHeight: 1.3
  }), (0, _defineProperty2.default)(_$concat, "&.".concat(_utilities.classes.components.MuiTooltip.tooltipPlacementBottom), {
    marginBottom: 0
  }), (0, _defineProperty2.default)(_$concat, "&.".concat(_utilities.classes.components.MuiTooltip.tooltipPlacementTop), {
    marginTop: 0
  }), (0, _defineProperty2.default)(_$concat, "backgroundColor", "white"), (0, _defineProperty2.default)(_$concat, "border", "1px solid ".concat(theme.palette.brand.grey.lightGrey)), (0, _defineProperty2.default)(_$concat, "borderRadius", "3px"), (0, _defineProperty2.default)(_$concat, "boxShadow", theme.shadows[3]), (0, _defineProperty2.default)(_$concat, "maxWidth", "14rem"), (0, _defineProperty2.default)(_$concat, "padding", theme.spacing(3)), _$concat)), (0, _defineProperty2.default)(_ref3, "color", isError ? theme.palette.error.main : undefined), (0, _defineProperty2.default)(_ref3, "fontWeight", isError ? "bold" : undefined), _ref3;
});
var StyledTypography = (0, _material.styled)(_Typography.Typography, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "isError";
  }
})(function (_ref4) {
  var theme = _ref4.theme,
      isError = _ref4.isError;
  return {
    color: isError ? theme.palette.error.main : undefined,
    fontWeight: isError ? "bold" : undefined
  };
});

var Tooltip = function Tooltip(_ref5) {
  var children = _ref5.children,
      title = _ref5.title,
      _ref5$variant = _ref5.variant,
      variant = _ref5$variant === void 0 ? "info" : _ref5$variant,
      rest = (0, _objectWithoutProperties2.default)(_ref5, _excluded2);
  var isError = variant === "error";
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTooltip, _objectSpread(_objectSpread({
    PopperProps: {
      role: isError ? "alert" : "status"
    },
    arrow: true,
    isError: isError,
    placement: "top",
    title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        alignItems: "flex-start",
        display: "flex",
        flexDirection: "row",
        children: [isError && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          color: "error",
          iconName: "exclamation-triangle",
          mr: 2
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTypography, {
          isError: isError,
          variant: "body3",
          children: title
        })]
      })
    })
  }, rest), {}, {
    children: children
  }));
};

var _default = Tooltip;
exports.default = _default;